import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface CheckXpoExportRequestParams {
  ClaimKey: number;
}

export const checkXpoExportAPI = (params: CheckXpoExportRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.LOSS_AND_DAMAGE}/isXPOCarrier`,
  });
};

export type CheckXpoExportResponse = string;

export const checkXpoExport = async (params: CheckXpoExportRequestParams): Promise<CheckXpoExportResponse> => {
  const response: AxiosResponse<CheckXpoExportResponse> = await checkXpoExportAPI(params);
  return response.data;
};
